export function createRideProductCatalogClient(transport) {
    return {
        /**
         * List tenant products effective at a point in time
         *
         * Requires scope: ride-product:read
         */
        getRideProducts(at, options) {
            return transport.request({
                method: "GET",
                path: "/v1/ride-products",
                query: { at: at },
                options,
            });
        },
        /**
         * Resolve latest, exact version, or effective product configuration
         *
         * Requires scope: ride-product:read
         */
        getRideProducts2(productId, version, at, options) {
            return transport.request({
                method: "GET",
                path: `/v1/ride-products/${encodeURIComponent(productId)}`,
                query: { version: version, at: at },
                options,
            });
        },
        /**
         * Create an immutable optimistic product configuration version
         *
         * Requires scope: ride-product:write
         */
        putRideProducts(productId, body, options) {
            return transport.request({
                method: "PUT",
                path: `/v1/ride-products/${encodeURIComponent(productId)}`,
                body,
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
    };
}
//# sourceMappingURL=ride-product-catalog.js.map